export { default } from "./CouponInput-component";
